export type ZIndiceName = 'cookieWall' | 'modalOverlay' | 'modal';

export type ZIndices = Record<ZIndiceName, number>;

export const zIndices: ZIndices = {
	cookieWall: 4990,
	modalOverlay: 5000,
	modal: 5001,
};
